//  ----------      START   IMPORT  BLOCK       ----------
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
//  ----------      END   IMPORT  BLOCK       ----------

function customNavLink({ handleSelect, tooltip, img_path, eventKey, active }) {

  return (
    <Nav.Link
    eventKey={eventKey}
    active={active}
    onClick={() => handleSelect(eventKey)}
    >
      <OverlayTrigger
        placement="right"
        overlay={<Tooltip id="calendar-tooltip">{tooltip}</Tooltip>}
      >
        <img
          src={img_path}
          alt={tooltip}
          style={{ width: '50px', height: '50px' }}
        />
      </OverlayTrigger>
    </Nav.Link>
  );
}

export default customNavLink;
